import { axiosInstance } from "../../../utils/AxiosInstance/AxiosInstance";

export const fetchOrganzationDetails = async () => {
    try {
        const response = await axiosInstance.get('/api/v2/common/masters/organization');
        return response.data;

    } catch (error) {
        console.log('Error fetching organization details:', error);
        throw new Error('Failed to fetch organization details');
    }
};
export const getUserBillingAddressByUserId = async (userId) => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/masters/get-billing-address-by-userid/${userId}`);
        return response.data;

    } catch (error) {
        console.log('Error fetching billing address details:', error);
        throw new Error('Failed to fetch billing address details');
    }
};

export const addBillingAddress = async (data) => {
    try {
        const response = await axiosInstance.post('/api/v2/common/masters/add-billing-address', data);
        return response.data;
    } catch (error) {
        console.log('Error adding billing address:', error);
        throw new Error('Failed to add billing address');
    }
};
export const deleteBillingAddress = async (id) => {
    try {
        const response = await axiosInstance.delete(`/api/v2/common/masters/delete-billing-address/${id}`);
        return response.data;
    } catch (error) {
        console.log('Error deleting billing address:', error);
        throw new Error('Failed to delete billing address');
    }
};
export const getBillingAddressById = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/masters/get-billing-address-by-id/${id}`);
        return response.data;
    }
    catch (error) {
        console.log('Error fetching billing address by ID:', error);
        throw new Error('Failed to fetch billing address by ID');
    }

};
export const updateBillingAddress = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/api/v2/common/masters/update-billing-address/${id}`, data);
        return response.data;
    } catch (error) {
        console.log('Error updating billing address:', error);
        throw new Error('Failed to update billing address');
    }
};
export const getCountry = async () => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/masters/get-country`);
        return response.data;
    } catch (error) {
        console.log('Error updating billing address:', error);
        throw new Error('Failed to update billing address');
    }
};
export const getAllShippingAddressByUserId = async (id) => {
    try {
        const response = await axiosInstance.get(`/api/v2/common/masters/get-all-shipping-address-by-userid/${id}`);
        return response.data;
    } catch (error) {
        console.log('Error updating billing address:', error);
        throw new Error('Failed to update billing address');
    }
};
export const downloadBatchFile = async (quoteId) => {
    try {
        const response = await axiosInstance.post(`/api/v2/common/masters/download-batch-file`, {
            quoteId
        }, { responseType: 'blob' });
        return response.data;
    } catch (error) {
        console.log('Error updating billing address:', error);
        throw new Error('Failed to update billing address');
    }
};
export const getDFMInfo = async (ids) => {
    try {
        const response = await axiosInstance.post(`/api/v2/common/masters/get-dfm-info-by-stagning-id-bulk`, {
            ids
        });
        return response.data;
    } catch (error) {
        console.log('Error updating billing address:', error);
        throw new Error('Failed to update billing address');
    }
};

export const getData = async (queries, debugLabel = 'get data') => {
    const safeDebugLabel = debugLabel.trim().replace(/\s+/g, '_');
    try {
        const payload = {
            queries,
            __debug: {
                label: safeDebugLabel,
                requestedAt: new Date().toISOString(),
            },
        };

        const response = await axiosInstance.post(`/api/v2/common/masters/get-data/${safeDebugLabel}`, payload);

        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch data');
    }
};

